import type { SidebarExtensionSDK } from '@contentful/app-sdk';
import { useSDK } from '@contentful/react-apps-toolkit';

export const useBuildDeployUrl = (environment: string) => {
  const sdk = useSDK<SidebarExtensionSDK>();

  return (path?: string) =>
    environment === 'production'
      ? new URL(path ?? '/', sdk.parameters.installation.prodDeployUrl)
      : new URL(path ?? '/', sdk.parameters.installation.deployUrl);
};
